import { getEnvArea } from "./utils";

export const config = {
  dev_cn: "//dev-api-gateway.starcharge.cloud/omc",
  test_cn: "//test-api-gateway.starcharge.cloud/omc",
  test_sg: "//test-api-gateway.starcharge.cloud/omcsub1",
  prod_cn: "//gateway.starcharge.com/omc",
  prod_sg: "//sg-omc.starcharge.com",
  prod_eu: "//eueaas-omc.starcharge.com",
  prod_us: "//omc-service-us.starcharge.com",
  uat_sg: "https://atmosphere-api-eaasuat.starcharge.com/omc",
};

export type ENV_AREA = keyof typeof config;

/**
 * 接口地址配置（本地环境统一走代理）
 */
const baseUrl = process.env.NODE_ENV === "development" ? "" : config[getEnvArea()];

export default baseUrl;
